<template>
  <span class="UIThinkingOrb" aria-hidden="true" />
</template>

<script lang="ts" setup>
/**
 * A soft indigo orb whose surface folds and turns while the assistant works. Decorative only:
 * the consumer carries the accessible status. Size it with `--orb-size`.
 *
 * Plays a sprite strip of frames taken from the design's sphere video: 40px square frames (2x the
 * default size) stacked vertically at 15fps, the last second cross-faded into the first so it
 * loops cleanly, and recoloured from the video's magenta to ui-lib's primary indigo with
 * glow-blue/glow-purple light.
 */
</script>

<style lang="scss" scoped>
$orb-frame-count: 150;
$orb-loop-duration: 10s;

.UIThinkingOrb {
  --orb-size: 1.25rem;
  display: inline-block;
  flex-shrink: 0;
  width: var(--orb-size);
  height: var(--orb-size);
  // The strip scaled to the orb's width, so each frame is exactly one orb tall.
  background: url('@/assets/images/thinking-orb.webp') 0 0 / 100% auto no-repeat;
  animation:
    UIThinkingOrb-play $orb-loop-duration steps($orb-frame-count) infinite,
    UIThinkingOrb-breathe 1.6s ease-in-out infinite;

  // Holds on the first frame.
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
}

@keyframes UIThinkingOrb-play {
  to {
    background-position-y: calc(var(--orb-size) * -#{$orb-frame-count});
  }
}

// Full colour always; the beat is size only.
@keyframes UIThinkingOrb-breathe {
  50% {
    transform: scale(0.88);
  }
}
</style>
